import { Resident } from '../../models/resident.model';
import { ResidentsService } from './../../../core/services/residents/residents.service';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ResidentNoteModalComponent } from './resident-note-modal/resident-note-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-resident-note',
  templateUrl: './resident-note.component.html',
  styleUrls: ['./resident-note.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class ResidentNoteComponent {
  @Input() resident: Resident;
  @Input() shouldBeWashy: boolean = false;
  @ViewChild('noteElement') noteElement: ElementRef;
  isNoteActive: boolean = false;
  noteRect: DOMRect;
  hideElements: boolean = false;
  constructor(
    private dialog: MatDialog,
    public permissionsService: PermissionsService
  ) {}

  openNoteModal() {
    if (this.hideElements || this.isNoteActive) {
      return;
    }
    this.isNoteActive = true;
    this.hideElements = true;
    const noteEl = this.noteElement.nativeElement;

    this.noteRect = noteEl.getBoundingClientRect();

    noteEl.style.position = 'fixed';
    noteEl.style.top = `${this.noteRect.top}px`;
    noteEl.style.left = `${this.noteRect.left}px`;

    void noteEl.offsetWidth;

    noteEl.style.top = '50%';
    noteEl.style.left = '50%';

    noteEl.addEventListener(
      'transitionend',
      () => {
        this.dialog
          .open(ResidentNoteModalComponent, {
            width: '400px',
            data: { resident: this.resident },
            panelClass: 'postit-dialog',
            backdropClass: 'transparent-backdrop',
            autoFocus: false,
          })
          .afterClosed()
          .subscribe(() => this.animateBack());
      },
      { once: true }
    );
  }

  animateBack() {
    const noteEl = this.noteElement.nativeElement;

    noteEl.style.position = 'fixed';
    void noteEl.offsetWidth;

    noteEl.style.top = `${this.noteRect.top + 15}px`;
    noteEl.style.left = `${this.noteRect.left + 12}px`;

    noteEl.addEventListener(
      'transitionend',
      () => {
        noteEl.style.position = '';
        noteEl.style.top = '';
        noteEl.style.left = '';
        this.hideElements = false;
      },
      { once: true }
    );
    this.isNoteActive = false;
  }
}
